export const mediaType = {
  NEXT:'Next',
  PREVIOUS:'Previous',
};
